import { create } from 'zustand';

const useMouse = create((set) => ({
  color: "white",
  toColor: (color) => set({color: "black"}), 
  type: 'default',
  toDefault: () => set({ type: 'default' }),
  toPointer: () => set({ type: 'pointer' }),
  toDrag: () => set({ type: 'drag' }),
  toHover: () => set({ type: 'hover' }),
  toSee: () => set({ type: 'see' }),
  toPlay: () => set({ type: 'play' })
}))

export default useMouse
